import { lazy, type ComponentType } from 'react';

function named(
  importer: () => Promise<Record<string, ComponentType<any>>>,
  exportName: string,
) {
  return lazy(() =>
    importer().then((mod) => ({ default: mod[exportName] })),
  );
}

export const LoginPage = named(() => import('@/modules/auth/pages/LoginPage'), 'LoginPage');
export const ForgotPasswordPage = named(
  () => import('@/modules/auth/pages/ForgotPasswordPage'),
  'ForgotPasswordPage',
);
export const ResetPasswordPage = named(
  () => import('@/modules/auth/pages/ResetPasswordPage'),
  'ResetPasswordPage',
);
export const ChangePasswordPage = named(
  () => import('@/modules/auth/pages/ChangePasswordPage'),
  'ChangePasswordPage',
);
export const ProfilePage = named(() => import('@/modules/auth/pages/ProfilePage'), 'ProfilePage');
export const ForbiddenPage = named(() => import('@/modules/auth/pages/ForbiddenPage'), 'ForbiddenPage');
export const DashboardPage = named(
  () => import('@/modules/dashboard/pages/DashboardPage'),
  'DashboardPage',
);
export const SocietyListPage = named(
  () => import('@/modules/society/pages/SocietyListPage'),
  'SocietyListPage',
);
export const SocietyRegisterPage = named(
  () => import('@/modules/society/pages/SocietyRegisterPage'),
  'SocietyRegisterPage',
);
export const SocietyDetailPage = named(
  () => import('@/modules/society/pages/SocietyDetailPage'),
  'SocietyDetailPage',
);
export const SocietySettingsPage = named(
  () => import('@/modules/society/pages/SocietySettingsPage'),
  'SocietySettingsPage',
);
export const ComplaintDashboardPage = named(
  () => import('@/modules/complaints/pages/ComplaintDashboardPage'),
  'ComplaintDashboardPage',
);
export const ComplaintListPage = named(
  () => import('@/modules/complaints/pages/ComplaintListPage'),
  'ComplaintListPage',
);
export const ComplaintCreatePage = named(
  () => import('@/modules/complaints/pages/ComplaintCreatePage'),
  'ComplaintCreatePage',
);
export const ComplaintDetailPage = named(
  () => import('@/modules/complaints/pages/ComplaintDetailPage'),
  'ComplaintDetailPage',
);
export const ServiceDirectoryPage = named(
  () => import('@/modules/services/pages/ServiceDirectoryPage'),
  'ServiceDirectoryPage',
);
export const ServiceRequestListPage = named(
  () => import('@/modules/services/pages/ServiceRequestListPage'),
  'ServiceRequestListPage',
);
export const ServiceRequestCreatePage = named(
  () => import('@/modules/services/pages/ServiceRequestCreatePage'),
  'ServiceRequestCreatePage',
);
export const ServiceRequestDetailPage = named(
  () => import('@/modules/services/pages/ServiceRequestDetailPage'),
  'ServiceRequestDetailPage',
);
export const ProviderActionPage = named(
  () => import('@/modules/services/pages/ProviderActionPage'),
  'ProviderActionPage',
);
export const VisitorDeskPage = named(
  () => import('@/modules/visitors/pages/VisitorDeskPage'),
  'VisitorDeskPage',
);
export const VisitorDetailPage = named(
  () => import('@/modules/visitors/pages/VisitorDetailPage'),
  'VisitorDetailPage',
);
export const SecurityCamerasPage = named(
  () => import('@/modules/security/pages/SecurityCamerasPage'),
  'SecurityCamerasPage',
);
export const NoticeListPage = named(
  () => import('@/modules/notices/pages/NoticeListPage'),
  'NoticeListPage',
);
export const NoticeCreatePage = named(
  () => import('@/modules/notices/pages/NoticeCreatePage'),
  'NoticeCreatePage',
);
export const NoticeDetailPage = named(
  () => import('@/modules/notices/pages/NoticeDetailPage'),
  'NoticeDetailPage',
);
export const WhatsAppLogsPage = named(
  () => import('@/modules/whatsapp/pages/WhatsAppLogsPage'),
  'WhatsAppLogsPage',
);
export const ResidentListPage = named(
  () => import('@/modules/residents/pages/ResidentListPage'),
  'ResidentListPage',
);
export const ResidentCreatePage = named(
  () => import('@/modules/residents/pages/ResidentCreatePage'),
  'ResidentCreatePage',
);
export const ResidentDetailPage = named(
  () => import('@/modules/residents/pages/ResidentDetailPage'),
  'ResidentDetailPage',
);
export const HouseListPage = named(
  () => import('@/modules/residents/pages/HouseListPage'),
  'HouseListPage',
);
export const HouseCreatePage = named(
  () => import('@/modules/residents/pages/HouseCreatePage'),
  'HouseCreatePage',
);
export const HouseDetailPage = named(
  () => import('@/modules/residents/pages/HouseDetailPage'),
  'HouseDetailPage',
);
export const HouseEditPage = named(
  () => import('@/modules/residents/pages/HouseEditPage'),
  'HouseEditPage',
);
export const MeetingListPage = named(
  () => import('@/modules/meetings/pages/MeetingListPage'),
  'MeetingListPage',
);
export const MeetingCreatePage = named(
  () => import('@/modules/meetings/pages/MeetingCreatePage'),
  'MeetingCreatePage',
);
export const MeetingDetailPage = named(
  () => import('@/modules/meetings/pages/MeetingDetailPage'),
  'MeetingDetailPage',
);
export const BankingPage = named(() => import('@/modules/banking/pages/BankingPage'), 'BankingPage');
export const FinancialReportsPage = named(
  () => import('@/modules/finance/reports/FinancialReportsPage'),
  'FinancialReportsPage',
);
export const PaymentReconciliationPage = named(
  () => import('@/modules/finance/reconciliation/PaymentReconciliationPage'),
  'PaymentReconciliationPage',
);
export const CollectionListPage = named(
  () => import('@/modules/collections/pages/CollectionListPage'),
  'CollectionListPage',
);
export const CollectionCreatePage = named(
  () => import('@/modules/collections/pages/CollectionCreatePage'),
  'CollectionCreatePage',
);
export const CollectionDetailPage = named(
  () => import('@/modules/collections/pages/CollectionDetailPage'),
  'CollectionDetailPage',
);
export const OwnerPaymentsPage = named(
  () => import('@/modules/collections/pages/OwnerPaymentsPage'),
  'OwnerPaymentsPage',
);
export const CorpusFundPage = named(
  () => import('@/modules/corpusFund/pages/CorpusFundPage'),
  'CorpusFundPage',
);
export const SocietyFundListPage = named(
  () => import('@/modules/collections/pages/SocietyFundListPage'),
  'SocietyFundListPage',
);
export const SocietyFundInitiatePage = named(
  () => import('@/modules/collections/pages/SocietyFundInitiatePage'),
  'SocietyFundInitiatePage',
);
export const SocietyFundDetailPage = named(
  () => import('@/modules/collections/pages/SocietyFundDetailPage'),
  'SocietyFundDetailPage',
);
export const ExpenseListPage = named(
  () => import('@/modules/expenses/pages/ExpenseListPage'),
  'ExpenseListPage',
);
export const ExpenseCreatePage = named(
  () => import('@/modules/expenses/pages/ExpenseCreatePage'),
  'ExpenseCreatePage',
);
export const ExpenseDetailPage = named(
  () => import('@/modules/expenses/pages/ExpenseDetailPage'),
  'ExpenseDetailPage',
);
export const ExpenseGroupListPage = named(
  () => import('@/modules/expenses/pages/ExpenseGroupListPage'),
  'ExpenseGroupListPage',
);
export const ExpenseGroupCreatePage = named(
  () => import('@/modules/expenses/pages/ExpenseGroupCreatePage'),
  'ExpenseGroupCreatePage',
);
export const ExpenseGroupDetailPage = named(
  () => import('@/modules/expenses/pages/ExpenseGroupDetailPage'),
  'ExpenseGroupDetailPage',
);
export const WaterTankerListPage = named(
  () => import('@/modules/expenses/pages/WaterTankerListPage'),
  'WaterTankerListPage',
);
export const WaterTankerCreatePage = named(
  () => import('@/modules/expenses/pages/WaterTankerCreatePage'),
  'WaterTankerCreatePage',
);
export const WaterTankerDetailPage = named(
  () => import('@/modules/expenses/pages/WaterTankerDetailPage'),
  'WaterTankerDetailPage',
);
export const SocietyLetterheadPage = named(
  () => import('@/modules/society/pages/SocietyLetterheadPage'),
  'SocietyLetterheadPage',
);
export const ReimbursementListPage = named(
  () => import('@/modules/expenses/pages/ReimbursementListPage'),
  'ReimbursementListPage',
);
export const ReimbursementClaimPage = named(
  () => import('@/modules/expenses/pages/ReimbursementClaimPage'),
  'ReimbursementClaimPage',
);
export const EventDashboardPage = named(
  () => import('@/modules/events/pages/EventDashboardPage'),
  'EventDashboardPage',
);
export const EventListPage = named(() => import('@/modules/events/pages/EventListPage'), 'EventListPage');
export const EventCreatePage = named(
  () => import('@/modules/events/pages/EventCreatePage'),
  'EventCreatePage',
);
export const EventDetailPage = named(
  () => import('@/modules/events/pages/EventDetailPage'),
  'EventDetailPage',
);
export const EventCalendarPage = named(
  () => import('@/modules/events/pages/EventCalendarPage'),
  'EventCalendarPage',
);
export const ElectionListPage = named(
  () => import('@/modules/elections/pages/ElectionListPage'),
  'ElectionListPage',
);
export const ElectionCreatePage = named(
  () => import('@/modules/elections/pages/ElectionCreatePage'),
  'ElectionCreatePage',
);
export const ElectionDetailPage = named(
  () => import('@/modules/elections/pages/ElectionDetailPage'),
  'ElectionDetailPage',
);
export const ElectionDashboardPage = named(
  () => import('@/modules/elections/pages/ElectionDashboardPage'),
  'ElectionDashboardPage',
);
export const CandidateNominatePage = named(
  () => import('@/modules/elections/pages/CandidateNominatePage'),
  'CandidateNominatePage',
);
export const VotingPage = named(() => import('@/modules/elections/pages/VotingPage'), 'VotingPage');
export const ElectionResultsPage = named(
  () => import('@/modules/elections/pages/ElectionResultsPage'),
  'ElectionResultsPage',
);
export const CertificateVerificationPage = named(
  () => import('@/modules/elections/pages/CertificateVerificationPage'),
  'CertificateVerificationPage',
);
export const MobileHomePage = named(() => import('@/mobile/pages/MobileHomePage'), 'MobileHomePage');
export const ComingSoonPage = named(() => import('@/mobile/pages/ComingSoonPage'), 'ComingSoonPage');
export const NotificationsPage = named(
  () => import('@/modules/notifications/pages/NotificationsPage'),
  'NotificationsPage',
);
export const RolesPage = named(() => import('@/modules/rbac/pages/RolesPage'), 'RolesPage');
export const RolePermissionsPage = named(
  () => import('@/modules/rbac/pages/RolePermissionsPage'),
  'RolePermissionsPage',
);
export const RbacAuditPage = named(() => import('@/modules/rbac/pages/RbacAuditPage'), 'RbacAuditPage');
export const GoogleCalendarSettingsPage = named(
  () => import('@/modules/settings/pages/GoogleCalendarSettingsPage'),
  'GoogleCalendarSettingsPage',
);
export const FactoryResetPage = named(
  () => import('@/modules/settings/pages/FactoryResetPage'),
  'FactoryResetPage',
);
export const PetitionBoardPage = named(
  () => import('@/modules/governance/pages/PetitionBoardPage'),
  'PetitionBoardPage',
);
export const ResignationPage = named(
  () => import('@/modules/governance/pages/ResignationPage'),
  'ResignationPage',
);
export const LicensePage = named(() => import('@/modules/license/pages/LicensePage'), 'LicensePage');
export const LicenseInvoicesPage = named(
  () => import('@/modules/license/pages/LicenseInvoicesPage'),
  'LicenseInvoicesPage',
);
export const SocietyStaffListPage = named(
  () => import('@/modules/staff/pages/SocietyStaffListPage'),
  'SocietyStaffListPage',
);
export const SocietyStaffCreatePage = named(
  () => import('@/modules/staff/pages/SocietyStaffCreatePage'),
  'SocietyStaffCreatePage',
);
export const SocietyStaffDetailPage = named(
  () => import('@/modules/staff/pages/SocietyStaffDetailPage'),
  'SocietyStaffDetailPage',
);
export const SocietyIntegrationsPage = named(
  () => import('@/modules/settings/pages/SocietyIntegrationsPage'),
  'SocietyIntegrationsPage',
);
export const MenuCustomizationPage = named(
  () => import('@/modules/society/pages/MenuCustomizationPage'),
  'default',
);

export const ImportHubPage = named(
  () => import('@/modules/imports/pages/ImportHubPage'),
  'ImportHubPage',
);
export const ImportHousesPage = named(
  () => import('@/modules/imports/pages/ImportHousesPage'),
  'ImportHousesPage',
);
export const ImportResidentsPage = named(
  () => import('@/modules/imports/pages/ImportResidentsPage'),
  'ImportResidentsPage',
);
export const ImportExpensesPage = named(
  () => import('@/modules/imports/pages/ImportExpensesPage'),
  'ImportExpensesPage',
);

// Dedicated Watchman & Security Pages
export const WatchmanLayout = named(
  () => import('@/modules/watchman/layouts/WatchmanLayout'),
  'WatchmanLayout',
);
export const WatchmanDashboardPage = named(
  () => import('@/modules/watchman/pages/WatchmanDashboardPage'),
  'WatchmanDashboardPage',
);
export const WatchmanScanPage = named(
  () => import('@/modules/watchman/pages/WatchmanScanPage'),
  'WatchmanScanPage',
);
export const WatchmanActiveVisitorsPage = named(
  () => import('@/modules/watchman/pages/WatchmanActiveVisitorsPage'),
  'WatchmanActiveVisitorsPage',
);
export const WatchmanEntriesListPage = named(
  () => import('@/modules/watchman/pages/WatchmanEntriesListPage'),
  'WatchmanEntriesListPage',
);
export const WatchmanIncidentPage = named(
  () => import('@/modules/watchman/pages/WatchmanIncidentPage'),
  'WatchmanIncidentPage',
);
export const WatchmanShiftPage = named(
  () => import('@/modules/watchman/pages/WatchmanShiftPage'),
  'WatchmanShiftPage',
);
export const GatePassListPage = named(
  () => import('@/modules/visitors/pages/GatePassListPage'),
  'GatePassListPage',
);
export const GatePassCreatePage = named(
  () => import('@/modules/visitors/pages/GatePassCreatePage'),
  'GatePassCreatePage',
);
export const SecurityAdminDashboardPage = named(
  () => import('@/modules/visitors/pages/SecurityAdminDashboardPage'),
  'SecurityAdminDashboardPage',
);
export const SecurityNotificationSettingsPage = named(
  () => import('@/modules/visitors/pages/SecurityNotificationSettingsPage'),
  'SecurityNotificationSettingsPage',
);
export const SecurityGatesPage = named(
  () => import('@/modules/visitors/pages/SecurityGatesPage'),
  'SecurityGatesPage',
);
export const SecurityShiftsReportPage = named(
  () => import('@/modules/visitors/pages/SecurityShiftsReportPage'),
  'SecurityShiftsReportPage',
);
export const EmergencyListPage = named(
  () => import('@/modules/emergency/pages/EmergencyListPage'),
  'EmergencyListPage',
);
export const EmergencyDetailPage = named(
  () => import('@/modules/emergency/pages/EmergencyDetailPage'),
  'EmergencyDetailPage',
);

// Super Admin Platform Pages
export const SuperAdminLayout = named(
  () => import('@/modules/superAdmin/layouts/SuperAdminLayout'),
  'SuperAdminLayout',
);
export const SuperAdminLoginPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminLoginPage'),
  'SuperAdminLoginPage',
);
export const SuperAdminDashboardPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminDashboardPage'),
  'SuperAdminDashboardPage',
);
export const SuperAdminSocietiesPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminSocietiesPage'),
  'SuperAdminSocietiesPage',
);
export const SuperAdminSocietyCreatePage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminSocietyCreatePage'),
  'SuperAdminSocietyCreatePage',
);
export const SuperAdminSocietyDetailPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminSocietyDetailPage'),
  'SuperAdminSocietyDetailPage',
);
export const SuperAdminPlansPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminPlansPage'),
  'SuperAdminPlansPage',
);
export const SuperAdminLicensesPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminLicensesPage'),
  'SuperAdminLicensesPage',
);
export const SuperAdminSubscriptionsPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminSubscriptionsPage'),
  'SuperAdminSubscriptionsPage',
);
export const SuperAdminTrialsPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminTrialsPage'),
  'SuperAdminTrialsPage',
);
export const SuperAdminInvoicesPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminInvoicesPage'),
  'SuperAdminInvoicesPage',
);
export const SuperAdminUsersPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminUsersPage'),
  'SuperAdminUsersPage',
);
export const SuperAdminFeaturesPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminFeaturesPage'),
  'SuperAdminFeaturesPage',
);
export const SuperAdminAnalyticsPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminAnalyticsPage'),
  'SuperAdminAnalyticsPage',
);
export const SuperAdminAuditLogsPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminAuditLogsPage'),
  'SuperAdminAuditLogsPage',
);
export const SuperAdminSystemHealthPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminSystemHealthPage'),
  'SuperAdminSystemHealthPage',
);
export const SuperAdminSettingsPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminSettingsPage'),
  'SuperAdminSettingsPage',
);
export const SuperAdminSocietyTypesPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminSocietyTypesPage'),
  'SuperAdminSocietyTypesPage',
);
export const SuperAdminMaintenancePage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminMaintenancePage'),
  'SuperAdminMaintenancePage',
);
export const SuperAdminPricingOverridesPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminPricingOverridesPage'),
  'SuperAdminPricingOverridesPage',
);
export const SuperAdminCouponsPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminCouponsPage'),
  'SuperAdminCouponsPage',
);
export const SuperAdminReferralsPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminReferralsPage'),
  'SuperAdminReferralsPage',
);
export const SuperAdminMarketingPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminMarketingPage'),
  'SuperAdminMarketingPage',
);
export const SuperAdminQACenterPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminQACenterPage'),
  'SuperAdminQACenterPage',
);

// Promotion & Outreach Subsystem Pages
export const PromotionDashboardPage = named(
  () => import('@/modules/superAdmin/promotion/pages/PromotionDashboardPage'),
  'PromotionDashboardPage',
);
export const PromotionProspectsPage = named(
  () => import('@/modules/superAdmin/promotion/pages/PromotionProspectsPage'),
  'PromotionProspectsPage',
);
export const PromotionCampaignsPage = named(
  () => import('@/modules/superAdmin/promotion/pages/PromotionCampaignsPage'),
  'PromotionCampaignsPage',
);
export const PromotionCampaignCreatePage = named(
  () => import('@/modules/superAdmin/promotion/pages/PromotionCampaignCreatePage'),
  'PromotionCampaignCreatePage',
);
export const PromotionCampaignDetailPage = named(
  () => import('@/modules/superAdmin/promotion/pages/PromotionCampaignDetailPage'),
  'PromotionCampaignDetailPage',
);
export const PromotionEmailPage = named(
  () => import('@/modules/superAdmin/promotion/pages/PromotionEmailPage'),
  'PromotionEmailPage',
);
export const PromotionWhatsAppPage = named(
  () => import('@/modules/superAdmin/promotion/pages/PromotionWhatsAppPage'),
  'PromotionWhatsAppPage',
);
export const PromotionSmsPage = named(
  () => import('@/modules/superAdmin/promotion/pages/PromotionSmsPage'),
  'PromotionSmsPage',
);
export const PromotionOtherChannelsPage = named(
  () => import('@/modules/superAdmin/promotion/pages/PromotionOtherChannelsPage'),
  'PromotionOtherChannelsPage',
);
export const PromotionTemplatesPage = named(
  () => import('@/modules/superAdmin/promotion/pages/PromotionTemplatesPage'),
  'PromotionTemplatesPage',
);
export const PromotionSenderProfilesPage = named(
  () => import('@/modules/superAdmin/promotion/pages/PromotionSenderProfilesPage'),
  'PromotionSenderProfilesPage',
);
export const PromotionAnalyticsPage = named(
  () => import('@/modules/superAdmin/promotion/pages/PromotionAnalyticsPage'),
  'PromotionAnalyticsPage',
);
export const PromotionSettingsPage = named(
  () => import('@/modules/superAdmin/promotion/pages/PromotionSettingsPage'),
  'PromotionSettingsPage',
);

// Marketing Portal Pages
export const MarketingDashboardPage = named(
  () => import('@/modules/marketing/pages/MarketingDashboardPage'),
  'MarketingDashboardPage',
);
export const MarketingReferralsPage = named(
  () => import('@/modules/marketing/pages/MarketingReferralsPage'),
  'MarketingReferralsPage',
);
export const MarketingCommissionsPage = named(
  () => import('@/modules/marketing/pages/MarketingCommissionsPage'),
  'MarketingCommissionsPage',
);
export const MarketingPayoutsPage = named(
  () => import('@/modules/marketing/pages/MarketingPayoutsPage'),
  'MarketingPayoutsPage',
);
export const MarketingProfilePage = named(
  () => import('@/modules/marketing/pages/MarketingProfilePage'),
  'MarketingProfilePage',
);

// Block / Tower Pages
export const BlockListPage = named(
  () => import('@/modules/society/pages/BlockListPage'),
  'BlockListPage',
);

// Invitation Module Pages
export const InvitationListPage = named(
  () => import('@/modules/invitations/pages/InvitationListPage'),
  'InvitationListPage',
);
export const InvitationCreatePage = named(
  () => import('@/modules/invitations/pages/InvitationCreatePage'),
  'InvitationCreatePage',
);
export const InvitationDetailPage = named(
  () => import('@/modules/invitations/pages/InvitationDetailPage'),
  'InvitationDetailPage',
);

// Community Forum Module Pages
export const ForumFeedPage = named(
  () => import('@/modules/forum/pages/ForumFeedPage'),
  'ForumFeedPage',
);
export const ForumCreatePostPage = named(
  () => import('@/modules/forum/pages/ForumCreatePostPage'),
  'ForumCreatePostPage',
);
export const ForumPostDetailPage = named(
  () => import('@/modules/forum/pages/ForumPostDetailPage'),
  'ForumPostDetailPage',
);

// AI Assistant Module Pages
export const AiChatPage = named(
  () => import('@/modules/ai/pages/AiChatPage'),
  'AiChatPage',
);
export const AiConfigPage = named(
  () => import('@/modules/ai/pages/AiConfigPage'),
  'AiConfigPage',
);

// Documentation & QA Pages
export const DocumentationListPage = named(
  () => import('@/modules/documentation'),
  'DocumentationListPage',
);
export const DocumentationDetailPage = named(
  () => import('@/modules/documentation'),
  'DocumentationDetailPage',
);
export const RoleMatrixPage = named(
  () => import('@/modules/documentation'),
  'RoleMatrixPage',
);
export const CoverageAuditPage = named(
  () => import('@/modules/documentation'),
  'CoverageAuditPage',
);

// Testing & QA Engine Pages
export const TestingDashboardPage = named(
  () => import('@/modules/testing'),
  'TestingDashboardPage',
);
export const TestCaseExplorerPage = named(
  () => import('@/modules/testing'),
  'TestCaseExplorerPage',
);
export const TestCaseExecutionPage = named(
  () => import('@/modules/testing'),
  'TestCaseExecutionPage',
);
export const CoverageMatrixPage = named(
  () => import('@/modules/testing'),
  'CoverageMatrixPage',
);

// Support Desk & Ticket Pages
export const SocietyTicketListPage = named(
  () => import('@/modules/support'),
  'SocietyTicketListPage',
);
export const SocietyTicketDetailPage = named(
  () => import('@/modules/support'),
  'SocietyTicketDetailPage',
);
export const SuperAdminTicketListPage = named(
  () => import('@/modules/support'),
  'SuperAdminTicketListPage',
);
export const SuperAdminTicketDetailPage = named(
  () => import('@/modules/support'),
  'SuperAdminTicketDetailPage',
);

export const SuperAdminFeatureRequestsPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminFeatureRequestsPage'),
  'SuperAdminFeatureRequestsPage',
);

export const SuperAdminDataCleanupPage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminDataCleanupPage'),
  'SuperAdminDataCleanupPage',
);

// Society Amenities & Facilities Pages
export const AmenityListPage = named(
  () => import('@/modules/amenities/pages/AmenityListPage'),
  'AmenityListPage',
);
export const AmenityDetailPage = named(
  () => import('@/modules/amenities/pages/AmenityDetailPage'),
  'AmenityDetailPage',
);
export const MyBookingsPage = named(
  () => import('@/modules/amenities/pages/MyBookingsPage'),
  'MyBookingsPage',
);
export const AmenityAdminDashboardPage = named(
  () => import('@/modules/amenities/pages/AmenityAdminDashboardPage'),
  'AmenityAdminDashboardPage',
);

// Financial Statements & Receipts
export const FinancialStatementsPage = named(
  () => import('@/modules/finance/pages/FinancialStatementsPage'),
  'FinancialStatementsPage',
);

// Resident Satisfaction & Polls
export const PollsListPage = named(
  () => import('@/modules/polls/pages/PollsListPage'),
  'PollsListPage',
);
export const PollAdminDashboardPage = named(
  () => import('@/modules/polls/pages/PollAdminDashboardPage'),
  'PollAdminDashboardPage',
);

// Digital Document Vault
export const DocumentVaultPage = named(
  () => import('@/modules/documents/pages/DocumentVaultPage'),
  'DocumentVaultPage',
);
export const DocumentDetailPage = named(
  () => import('@/modules/documents/pages/DocumentDetailPage'),
  'DocumentDetailPage',
);

export const SuperAdminWebsitePage = named(
  () => import('@/modules/superAdmin/pages/SuperAdminWebsitePage'),
  'SuperAdminWebsitePage',
);

